export enum FieldType {
	Loom = 'loom',
	Cards = 'cards',
	Table = 'table',
	Search = 'search',
	Stripe = 'stripe',
	Iframe = 'iframe',
	Gallery = 'gallery',
	Divider = 'divider',
	AIInput = 'ai-input',
	Calendly = 'calendly',
	Dropdown = 'dropdown',
	TextInput = 'text-input',
	FileInput = 'file-input',
	DatePicker = 'datepicker',
	EmailInput = 'email-input',
	GoogleDocs = 'google-docs',
	AudioInput = 'audio-input',
	VideoPlayer = 'video-player',
	Switch = 'switch-field-type',
	TableMapper = 'csv-importer',
	NumberInput = 'number-input',
	ImageEditor = 'image-editor',
	WidgetFooter = 'widget-footer',
	ImageDisplay = 'image-display',
	RichTextInput = 'rich-text-input',
	EndRunButtons = 'end-run-buttons',
	DateTimePicker = 'date-time-picker',
	ParagraphOutput = 'paragraph-output',
	HubSpotScheduler = 'hubspot-scheduler',
	CascadingDropdown = 'cascading-dropdown',
	CredentialsSelector = 'credentials-selector',
	UserSchemaMappingsSelector = 'user-schema-mappings-selector',
}
export const AI_DEFAULT_MAX_WORDS = 1400;
export const FIELDS_RECEIVING_HTML_AS_INPUT = [FieldType.ParagraphOutput, FieldType.RichTextInput]; // Either using RichTextBox or v-html etc.
export const READ_ONLY_WIDGET_FIELDS = [FieldType.ParagraphOutput, FieldType.Iframe, FieldType.WidgetFooter];
export const NONE_INTERFACE_CONFIGURATION_ONLY_FIELDS = [FieldType.CredentialsSelector, FieldType.UserSchemaMappingsSelector];
